// extracted by mini-css-extract-plugin
export default {"selected":"_6c43018fd5","un":"e35022f530"};